/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_PodcastInputs */

const en_nav_podcast = /** @type {(inputs: Nav_PodcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podcast`)
};

const es_nav_podcast = /** @type {(inputs: Nav_PodcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podcast`)
};

/**
* | output |
* | --- |
* | "Podcast" |
*
* @param {Nav_PodcastInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_podcast = /** @type {((inputs?: Nav_PodcastInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_PodcastInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_podcast(inputs)
	return en_nav_podcast(inputs)
});